import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Icon} from './Icon';

import './LazyLoadedComponent.scss';

class LazyLoadedComponent extends Component<jsx.Props, jsx.State> {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {loadedComponent: null};
    }
    componentWillUpdate(nextProps: jsx.Props, state: jsx.State) {
        if (this.props.importPromiseFunc !== nextProps.importPromiseFunc) {
            this.setState({loadedComponent: null});
        }
    }
    render() {
        const LoadedComponent: Inferno.InfernoComponent|null =
            this.state!.loadedComponent;
        const {importPromiseFunc, attr, ...props} = this.props;
        if (!LoadedComponent) {
            process.env.BROWSER && importPromiseFunc().then(
                (loadedModule: any) => {
                    this.setState({loadedComponent: loadedModule[attr]});
                });
            return null;
        }
        return <LoadedComponent {...props}/>;
    }
}

export default function lazyLoadComponent(
    importPromiseFunc: Function, attr: string, preloadDelayMS?: number) {
    let ServerSideComponent: Inferno.InfernoComponent;
    if (!process.env.BROWSER) {
        lazyLoadComponent.promises.push(
            importPromiseFunc().then((loadedModule: any) => {
                ServerSideComponent = loadedModule[attr];
            }));
    } else if (preloadDelayMS >= 0) {
        window.setTimeout(importPromiseFunc, preloadDelayMS || 500);
    }
    return (props: jsx.Props) => {
        if (ServerSideComponent) {
            return <ServerSideComponent {...props}/>;
        }
        return <LazyLoadedComponent
            importPromiseFunc={importPromiseFunc}
            attr={attr}
            {...props}
        />;
    };
}
lazyLoadComponent.promises = [] as Promise<void>[];
